import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputComponent } from '../base-input/base-input.component';
import { ISelectOption } from './select-option.interface';

@Component({
  selector: 'select-base',
  templateUrl: './base-select.component.html',
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseSelectComponent),
    multi: true
  } ]
})
export class BaseSelectComponent extends BaseInputComponent {

  @Input('showEmptyValue') showEmptyValue: boolean = false;
  @Input() options: ISelectOption[] = [];
}
